import { render, staticRenderFns } from "./Irregularidades.vue?vue&type=template&id=c1c74bda&"
import script from "./Irregularidades.vue?vue&type=script&lang=js&"
export * from "./Irregularidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports